import { create } from "zustand";

interface IFeeStates {
  paymentFee: number;
  deliveryFee: number;
  taxFee: number;
  subtotal: number;
  subtotalMultiPayment: number;
  discount: number;
  discountPercentage: number;
  setPaymentFee: (fee: number) => void;
  setDeliveryFee: (fee: number) => void;
  setTaxFee: (fee: number) => void;
  setSubtotal: (amount: number) => void;
  setSubtotalMultiPayment: (amount: number) => void;
  setDiscount: (amount: number) => void;
  setDiscountPercentage: (amount: number) => void;
}

export const useFeeStore = create<IFeeStates>((set) => ({
  paymentFee: 0,
  deliveryFee: 0,
  taxFee: 0,
  subtotal: 0,
  subtotalMultiPayment: 0,
  discount: 0,
  discountPercentage: 0,
  setPaymentFee: (fee) => set({ paymentFee: fee }),
  setDeliveryFee: (fee) => set({ deliveryFee: fee }),
  setTaxFee: (fee) => set({ taxFee: fee }),
  setSubtotal: (amount) => set({ subtotal: amount }),
  setSubtotalMultiPayment: (amount) => set({ subtotalMultiPayment: amount }),
  setDiscount: (amount) => set({ discount: amount }),
  setDiscountPercentage: (amount) => set({ discountPercentage: amount }),
}));

// TODO: DOES NOT WORK
interface IShippingFormStates {
  isValidPhone: boolean;
  showPhoneCompleted: boolean;
  showPhone: boolean;
  isValidAddress: boolean;
  showShippingAddress: boolean;
  showSignIn: boolean;
  setIsValidPhone: (value: boolean) => void;
  setShowPhoneCompleted: (value: boolean) => void;
  setShowPhone: (value: boolean) => void;
  setIsValidAddress: (value: boolean) => void;
  setShowShippingAddress: (value: boolean) => void;
  setShowSignIn: (value: boolean) => void;
}

export const useShippingFormStore = create<IShippingFormStates>((set) => ({
  isValidPhone: false,
  showPhoneCompleted: false,
  showPhone: true,
  isValidAddress: false,
  showShippingAddress: false,
  showSignIn: false,
  setIsValidPhone: (value) => set({ isValidPhone: value }),
  setShowPhoneCompleted: (value) => set({ showPhoneCompleted: value }),
  setShowPhone: (value) => set({ showPhone: value }),
  setIsValidAddress: (value) => set({ isValidAddress: value }),
  setShowShippingAddress: (value) => set({ showShippingAddress: value }),
  setShowSignIn: (value) => set({ showSignIn: value }),
}));
